import { render } from "./Patient.vue?vue&type=template&id=11a52ab0"
import script from "./Patient.vue?vue&type=script&lang=js"
export * from "./Patient.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__